<script lang="ts">
    import * as yup from 'yup';
    import {Form, Message, isInvalid} from 'svelte-yup';
    import { createEventDispatcher} from 'svelte';
    import { Lead } from '../models/Lead';
    import { get } from 'svelte/store';
    import { FinProBaseUrl } from '../services/Store';
    import { GetValueFromCookies } from '../services/ApplicationDataServices';
    import Button from './controls/Button.svelte';

    export let open = false;    
    export let onClosed;    
    export let isValid:boolean;      

    const modalClose = () => {
        open = false;
        doneSubmitted=false;
        if (onClosed) {
            onClosed();
        }
    }

    const dispatch = createEventDispatcher();  
    
    let buttontext = "Download";
    let showBackdrop = true; 
    let lead:Lead = new Lead();
    let baseurl = get<String>(FinProBaseUrl);   
    let submitted:boolean = false;
    let doneSubmitted:boolean = false;    

    let schema = yup.object().shape({     
        firstName: yup.string().required().label("First name"),
        lastName: yup.string().required().label("Last name"),   
        email: yup.string().required().email().label("Email"),
        firm: yup.string().required().label("Firm"),
        zipCode: yup.string().matches(/^\d{5}$/, "Please enter a 5 digit zip code").label("Zip Code*"),
        authorized: yup.boolean().required("License is required.").oneOf([true],"License is required.")       
    });
    let fields = {firstName: "", lastName: "", email: "", firm: "", zipCode:"", authorized:false};        
    const saveLead = () => {       
        submitted = true;
        isValid = schema.isValidSync(fields);
        if (!isValid) return;
        let sessionid:any = document.cookie.match(/SessionId=[^;]+/); 

        GetValueFromCookies(lead, fields);

        if(sessionid !== null){
            lead.sessionid = sessionid.toString().substring(10) ;
        }
        else{
            lead.sessionid="empty";
        }               
        storeCookie();
        doneSubmitted=true;                    
        findLead();
        dispatch('showPdf');    
    }   
    
    const storeCookie= () =>{
        document.cookie = "estateMaxModalPDFForm =  FirstName: " + fields.firstName + ", LastName: " +  fields.lastName + ", Firm:" + fields.firm + ", Email:" + fields.email + ",Zip:" + fields.zipCode + ",SessionId:";
    }
    export async function findLead() {       
        let leadId = await findFormSubmit();       
        if(leadId > 0){            
            updateLeadCount(leadId); 
        }
        else{            
            saveLeadForm();
        }
    }
    export async function findFormSubmit(){             
        let url = encodeURI(baseurl + "FindLeadForm");
        const response = await fetch (url, {
            method: 'POST',           
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'Accept':'application/json',     
                'Origin':'*'           
            },
            body:  JSON.stringify(lead)            
        });       
        return response.json();
    }
    export async function updateLeadCount(id){     
        let url = baseurl + "UpdateCount?id=" + id;
        const response = await fetch (url, {
            method: 'POST',           
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'Accept':'application/json',     
                'Origin':'*'           
            }                        
        });       
        return response.json();
    }
    export async function saveLeadForm(){           
        let url = baseurl + "CreateLeadForm";
        const response = await fetch (url, {
            method: 'POST',           
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'Accept':'application/json',     
                'Origin':'*'           
            },
            body:  JSON.stringify(lead)            
        });       
        return response.json();
    }
    
    $: invalid = (name)=>{
        if(submitted){
            return isInvalid(schema, name, fields);
        }
        return false;
    }
    $: valid = (name)=>{       
        return !isInvalid(schema, name, fields);
    }
</script>

{#if open}
<div class="container content">
  <div class="modal" id="sampleModal" tabindex="-1" role="dialog" aria-labelledby="sampleModalLabel" aria-hidden={false}>
      <div class="modal-content">
        <div class="modal-header">
            <div class="close-icon" on:click={() => modalClose()}>
                close
            </div>  
        </div>
        <div class="modal-body">
            <slot>         
                <div class="col-sm-12 col-md-5 imgPanel">    
                    <div class="image">             
                    </div>
                </div>  
                <div class="col-sm-12 col-md-7 formPanel">
                    {#if !doneSubmitted}
                    <div class="rightSide">
                        <Form {schema} {fields} submitHandler={saveLead} {submitted}>  
                            <div class="leadForm">      
                                <h1 class="cta">
                                    Download a summary report for Protective Series Estate Maximizer
                                </h1>
                                <p class="required">*Required fields</p>  
                           
                                <div class="form-group">
                                    <label for="firstName">First name*</label>
                                    <input id="firstName" type="text" class="form-control leadtextbox" class:invalid={invalid("firstName")} class:valid={valid("firstName")} bind:value={fields.firstName}>                           
                                    <Message name="firstName" />
                                </div>
                                <div class="form-group">
                                    <label for="lastName">Last name*</label>
                                    <input id="lastName" type="text" class="form-control leadtextbox" class:invalid={invalid("lastName")} class:valid={valid("lastName")} bind:value={fields.lastName}>
                                    <Message name="lastName" />
                                </div>
                                <div class="form-group">
                                    <label for="email">Email*</label>
                                    <input id="email" type="text" class="form-control leadtextbox" class:invalid={invalid("email")} class:valid={valid("email")} bind:value={fields.email}>
                                    <Message name="email" />
                                </div>
                                <div class="form-group">               
                                    <label for="firm">Firm*</label>
                                    <input type="text" id="firm" class="form-control leadtextbox" class:invalid={invalid("firm")} class:valid={valid("firm")} bind:value={fields.firm}>
                                    <Message name="firm" />
                                </div>
                                <div class="form-group">
                                    <label for="zipCode">Zip code*</label>
                                    <input type="text" id="zipCode" class="form-control leadtextbox" class:invalid={invalid("zipCode")} class:valid={valid("zipCode")} bind:value={fields.zipCode}>
                                    <Message name="zipCode" />
                                </div>   
                                <div class="form-group">   
                                    <ul>
                                        <li>
                                            <div><input id="authorized" type=checkbox  class="authorized" class:invalid={invalid("authorized")} bind:checked={fields.authorized}></div>
                                            <div><label for="authorized" class = "checkText">I'm authorized through my Firm to offer life and annuity products.</label></div>
                                        </li>
                                    </ul>              
                                   
                                    <Message name="authorized" />
                                </div> 
                                <Button bind:buttontext />                                  
                                <div class="description">
                                    Disclosure: The information collected in this form by Protective will be used to offer you services that meet your needs and for other business purposes. Please <a href="https://www.protective.com/privacy-policy/">visit our Privacy Policy</a> for more information about our information practices, including information about your privacy choices.        
                                </div>
                            </div>                       
                        </Form>                   
                       
                    </div>
                    {/if}
                    {#if doneSubmitted}   
                        <div class="rightside">
                            <div class="checkmark">
                                <div class="done-icon">                         
                                    done                            
                                </div>
                            </div>
                            <div class="leadheader">Thanks for your interest</div>
                            <p class="materials">
                                The materials you've requested should have downloaded automatically or opened in a new window. For questions, please contact us <a href="https://finpro.protective.com/about-us/contact-us" >here</a>.
                            </p>                   
                        </div>          
                    {/if}      
                </div>               
           </slot> 
        </div>       
      </div>
  </div>
</div>
  {#if showBackdrop}
    <div class="modal-backdrop show"></div>
  {/if}
{/if}
<style lang="scss">  
  .invalid {
        border-color: red !important;   
        color:red !important;     
    } 
    .valid{
        border-color: #50C3FF !important;   
    }
    h1.cta{
        position: static;
        width: 100%;       
        left: 0px;
        top: 20px;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 32px;      
        display: flex;
        align-items: center;
        text-align: left;
        color: #000000;        
        margin: 32px 0px 24px;
        @media(max-width:992px){     
            max-width:375px;    
            margin-left: 10px;            
        }   
    }
    p.required{
        margin:0px 0px 24px 0px;
        font-family: Open Sans;
        font-size: 16px;
        line-height: 26px;     
        width:100%; 
        @media(max-width:992px){           
            margin-left: 10px;
            margin-top: 10px;
        }   
    }
    .description{      
        width: 100%;   
        height: 90px;  
        text-align: left;
        align-content: center;     
        font-family: 'Open Sans Condensed';
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 30px;     
        color: #000000;         
        margin-top: 24px;
        @media(max-width:992px){
            max-width:335px;
            margin-left: 10px;            
        }
    }
    .imgPanel{
        padding:0px !important;
        background-color: #F7F7F7;
        white-space: normal;
        @media(max-width:992px){           
            width:375px;      
            height: 176px; 
            max-height:176px;
            white-space: normal;   
            
        }   
    }
    .formPanel{
        height:100%;
        padding:0px !important;
        background-color: #F7F7F7;
        white-space: normal;
        min-height: 930px;
        @media(max-width:992px){           
            width:375px;                  
            white-space: normal;   
            padding-left: 20px;
            padding-right: 20px;
            height: 100%;
            min-height: 1100px;
        }   
    }
    .rightSide{
        display: flex;
        flex-direction: column;       
        vertical-align: middle;
        align-items: center;      
        width: 100%;     
        max-width: 805px;          
        min-height: 930px;
        background-color: #F7F7F7;              
        overflow: visible;       
        @media(max-width:992px){            
            width:100%;
            max-width: 375px;    
            padding-left: 20px;        
            padding-right: 20px;
            height:100%;
        }
    }
    .image{
        display: flex;
        flex-direction: column;
        align-items: flex-start;      
        background-color: #F7F7F7;
        max-width: 559px;
        min-height: 930px;
        height: 100%;           
        background-image: url("../images/estate-max-calculator-form.jpg");      
        background-repeat: no-repeat;     
        @media(max-width:992px){
            width: 375px;   
            height:176px;
            max-height:176px;
            background-image: url("../images/media.jpg");     
            background-size: 375px 176px;      
            min-height: 176px;      
        }
    }
    .leadForm{       
        padding-left: 115px;
        padding-right: 131px;
        @media(max-width:992px){
            width: 335px;
            margin-left: 10px;
            padding-left: 20px;
            padding-right: 20px;
        }
    }      
    input.authorized{
        margin: 12px 12px 12px 0;          
        accent-color: #4C12A1;
        color:white;
        display:inline;  
        transform: scale(1.5);
        @media(max-width:992px){            
            max-width: 375px;
            margin-left: 10px;
        }  
    }     
    .checkmark{
        margin:auto;
        color: #7D55C7;   
        text-align: center;                
        margin: 287.54px auto 76.62px;
        width:100%;
        @media(max-width:992px){
            max-width:335px;   
            margin-top: 42px;
            margin-bottom:65px;       
        }   
    }
    .leadheader{
        position: static;
        width: 100%;
        height: 44px;
        flex-direction: column;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 34px;
        line-height: 44px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #000000;
        flex: none;       
        @media(max-width:992px){
            max-width: 335px;
            margin-left: auto;
            margin-right: auto;    
            font-size: 26px;
            line-height: 36px;     
        }        
    }
    p.materials{
        position: static;
        width: 100%;           
        font-family: Open Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        margin-top: 24px;
        color: #000000;       
        align-self: stretch;      
        @media(max-width:992px){
            max-width:335px;
            line-height: 24px;
            margin-left: auto;
            margin-right: auto;   
        }   
    }
    .checkText{
        font-family: 'Open Sans';
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        display:inline;
        @media(max-width:992px){
            max-width:335px;
            margin-left: 0;
        } 
        
    }
    label{
        font-family: Open Sans;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        @media(max-width:992px){
            width:100%;
            margin-left: 10px;
        }
    }   
    a{
        text-decoration: underline;
        color:#000000;
    }
    .done-icon{
        content: "done";
        font-family: "Material Icons Outlined";
        font-size: 68px;       
        color:#7D55C7;  
        margin-bottom:76px;   
        @media(max-width:992px){
            max-width:335px;          
        }     
    }    
    .leadtextbox{      
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items: flex-start;
        padding: 10px 0px;
        position: static;
        width: 100%;
        height: 48px;
        left: 0px;
        top: 32px;
        background: #FFFFFF;      
        border: 2px solid #C6C6C6;
        box-sizing: border-box;
        border-radius: 100px;
        align-self: stretch;
        margin: 4px 0px 12px 0px;   
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 30px;        
        display: flex;
        align-items: center;
        color: #696969;
        text-indent: 16px;
        @media(max-width:992px){
            width: 95%;           
        }
        
    }  
    .leadtextbox::content{
        border: 2px solid #50C3FF;
        font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 30px;
    }  
    .close-icon{
        content: "close";
        font-family: "Material Icons Outlined";
        font-size: 24px;
        position: relative;        
        margin:auto 20px auto 0px;   
        color:white;  
        @media(max-width:992px){
           margin-right: 5px;
        }          
    }  
    .modal-body{
        display: flex;
        padding:0px;   
        flex-direction: row;
        overflow: auto;
        @media(max-width:992px){
            flex-direction: column; 
            width:100%;
            max-width: 375px;                     
        }          
    }
    .modal-header {
        display: flex;
        justify-content: right;    
        background-color: #4C12A1;
        color: white;
        width: 1364px;
        height:60px !important;
        position:relative;           
        @media(max-width:992px){
            width:100%;
            max-width: 375px;
        }
    }   
    .modal-content{
        width:100%;
        max-width: 1364px;
        @media(max-width:992px){
            width:100%;            
            max-width: 375px;    
            top:0;   
            padding:0;          
        }
    }
    .modal{
        padding: 0px;            
        display: flex; 
        flex-direction: column;           
        max-width:1364px;
        max-height: 990px;
        left: 50%;   
        top:50%;    
        transform: translate(-50%, -50%);   
        overflow-y: auto;
        z-index: 1002;   
        justify-content: normal;
        width:100%;
        @media(max-width:992px){
            width:100%;                                                                   
            max-height:1500px !important;                     
        }
    }    
    .modal-backdrop{
        position: fixed;
        left: 50%;   
        top:50%;    
        transform: translate(-50%, -50%);   
        opacity: 45% !important;
        background-color:#000000;
        height: 100%;
        width:100%;   
        z-index: 1001;     
        @media(max-width:992px){
            height: 2000px;
            width:100vw;    
        }
    }
    a{
        color:#4C12A1
    }
    .modal {
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
    }
    .modal::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
    }   
    li div { display: table-cell; vertical-align: middle; }
    li {list-style: none;}
    ul {padding:0}
</style>
